<template>
  <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">settings</p>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success">Save changes</button>
          <button class="button">Cancel</button>
        </footer>
      </div>
</template>

<script>
export default {
}
</script>
